export default __webpack_public_path__ + "static/media/21.4ff4a8cd.png";